module.exports = __webpack_public_path__ + "img/document.4754dc41.svg";